<div class="account-stop">
  <div class="account-stop-card" role="alert" aria-live="polite">
    <img src="/assets/images/logo2.png" alt="ACFS" class="account-stop-logo"/>
    <span class="account-stop-icon" aria-hidden="true">
      <i class="bi bi-person-x"></i>
    </span>
    <h1 class="account-stop-title">ไม่พบบัญชีผู้ใช้ในระบบ</h1>
    <p class="account-stop-text">
      @if (username()) {
        บัญชี <strong>{{ username() }}</strong> ยังไม่ได้ลงทะเบียนใน e-Portal
      } @else {
        บัญชีนี้ยังไม่ได้ลงทะเบียนใน e-Portal
      }
      — กรุณาเข้าสู่ระบบ e-Portal ให้เรียบร้อยก่อน แล้วกลับมาที่ ACFS Supply Chain อีกครั้ง
    </p>
    <div class="account-stop-actions">
      <button type="button" class="btn btn-primary" id="account-stop-portal" (click)="goToPortal.emit()">
        <i class="bi bi-box-arrow-up-right me-1" aria-hidden="true"></i> ไปที่ e-Portal
      </button>
      <button type="button" class="btn btn-link text-secondary" id="account-stop-logout" (click)="logout.emit()">
        ออกจากระบบ
      </button>
    </div>
  </div>
</div>
